import { isAfter, isBefore, parseISO } from 'date-fns';
// API DAP response adapters

import { showAdapterErrors } from './index';

/**
 * Adapts the new structure of the plan that include custom_activities
 * @param plan
 * @returns plan
 */
export const planAdapter = (plan: any) => {
  try {
    const adaptedDays = plan.days.map((day: any) => {
      const adaptedDayProgramme = day.skill_programme_activities.map((activityContainer: any) => {
        const customOrNotContainer = {
          ...activityContainer,
          activity: activityContainer.activity || adaptCustomActivity(activityContainer.custom_activity),
        };
        delete customOrNotContainer.custom_activity;
        return customOrNotContainer;
      });
      return { ...day, skill_programme_activities: adaptedDayProgramme };
    });

    return { ...plan, days: adaptedDays };
  } catch (e) { if (showAdapterErrors) console.error(e); }

  return plan;
};

/**
 * Adapts the use of two diferent arrays for materials: material[] & custom_material[]
 * @param dapMaterials
 */
export const dapMaterialsAdapter = (dapMaterials: any) => {
  try {
    const adaptedDays = dapMaterials.data.days.map((day: any) => ({
      ...day,
      material: [...day.material, ...day.custom_material],
    }));
    return { ...dapMaterials, data: { ...dapMaterials.data.days, days: adaptedDays } };
  } catch (e) { if (showAdapterErrors) console.error(e); }

  return dapMaterials;
};


const defaultActivityOwner = {
  id: 2,
  name: 'Default',
  last_name: 'Owner',
  user_id: 21,
};

const mediaSizes = ['size1', 'size2', 'size3', 'size4', 'size5', 'size6'];

// Entities
export const adaptCustomActivity = (customActivity: any) => {
  try {
    const s3File = customActivity.s3_files[0];
    if (s3File) {
      const mp4Url = s3File.service_urls.filter((url: any) => url.record_type === 'mp4_url')[0].url;
      const thumbnailUrl = s3File.service_urls.filter((url: any) => url.record_type === 'thumbnail_url')[0]?.url;
      const videoMedia = mediaSizes.reduce((current: any, size: any) => {
        current[size] = mp4Url;
        return current;
      }, {});
      const videoThumbnails = mediaSizes.reduce((current: any, size: any) => {
        current[size] = thumbnailUrl;
        return current;
      }, {});

      return { ...customActivity, video_thumbnails: videoThumbnails, video_media: videoMedia, isCustom: true };
    }
  } catch (e) { if (showAdapterErrors) console.error(e); }

  return { ...customActivity, isCustom: true };
};

// Endpoint Response Data
export const customActivityAdapter = (data: any) => {
  try {
    data.custom_activity = adaptCustomActivity(data.custom_activity);
    return {
      ...data,
      custom_activity_owner: { ...defaultActivityOwner, ...data?.custom_activity?.custom_activity_owner },
    };
  } catch (e) { if (showAdapterErrors) console.error(e); }
  return data;
};

export const customActivitiesAdapter = (data: any) => {
  try {
    const adaptedCustomActivities = data.custom_activities.map(customActivityAdapter);
    return { ...data, custom_activities: adaptedCustomActivities };
  } catch (e) { if (showAdapterErrors) console.error(e); }

  return data;
};

export const collectionResourcesAdapter = (data: any) => {
  try {
    const adaptedCustomActities = data.resources.map(adaptCustomActivity);
    return { ...data, resources: adaptedCustomActities };
  } catch (e) { if (showAdapterErrors) console.error(e); }

  return data;
};

export const sortDapsByFirstActivity = (allDapIdList: any, reverse?: boolean) => allDapIdList.sort((dapA: any, dapB: any) => {
  if (isBefore(parseISO(dapA.first_activity_on), parseISO(dapB.first_activity_on))) return reverse ? 1 : -1;
  if (isAfter(parseISO(dapA.first_activity_on), parseISO(dapB.first_activity_on))) return reverse ? -1 : 1;
  return 0;
});

/**
 * Sort dapIdList in order of creation
 * @param allDapIdList
 */
export const dapAllDapIdsAdapter = (allDapIdList: any[]) => {
  try {
    sortDapsByFirstActivity(allDapIdList);
  } catch (e) { if (showAdapterErrors) console.error(e); }

  return allDapIdList;
};
